// frontend-web/src/pages/Admin/ViewPracticeSet.jsx
import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate, useParams } from "react-router-dom";

export default function ViewPracticeSet() {
  const [practiceSet, setPracticeSet] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const nav = useNavigate();

  useEffect(() => {
    loadPracticeSet();
  }, [id]);

  const loadPracticeSet = async () => {
    try {
      setLoading(true);
      const res = await api.get(`/admin/practice_set/${id}`);
      setPracticeSet(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to load Practice Set");
      nav("/admin/practice-set-list");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f8fafc" }}>
        <p style={{ fontSize: 20, color: "#475569" }}>Loading Practice Set...</p>
      </div>
    );
  }

  if (!practiceSet) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <p style={{ fontSize: 20, color: "#ef4444" }}>Practice Set not found</p>
        <button
          onClick={() => nav("/admin/practice-set-list")}
          style={{
            marginTop: 20,
            padding: "12px 24px",
            background: "#3b82f6",
            color: "white",
            border: "none",
            borderRadius: 8,
            cursor: "pointer"
          }}
        >
          Back to List
        </button>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamily: "Inter, sans-serif" }}>
      {/* Header */}
      <div style={{ padding: "20px 40px", background: "white", borderBottom: "1px solid #e2e8f0" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <button
            onClick={() => nav("/admin/practice-set-list")}
            style={{
              padding: "10px 16px",
              background: "#e2e8f0",
              color: "#475569",
              border: "none",
              borderRadius: 8,
              cursor: "pointer"
            }}
          >
            ← Back to List
          </button>
          <h1 style={{ margin: 0, fontSize: 28, fontWeight: 700 }}>View Practice Set: #{id}</h1>
        </div>
      </div>

      <div style={{ padding: 40 }}>
        {/* Info Card */}
        <div style={{ background: "white", padding: 24, borderRadius: 16, boxShadow: "0 4px 20px rgba(0,0,0,0.05)", marginBottom: 30 }}>
          <h2 style={{ margin: "0 0 20px", color: "#1e293b" }}>{practiceSet.name}</h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 20 }}>
            <div style={{ background: "#f0fdf4", padding: 16, borderRadius: 12 }}>
              <label style={labelStyle}>Class ID</label>
              <p style={{ fontSize: 18, fontWeight: 600 }}>{practiceSet.class_id}</p>
            </div>
            <div style={{ background: "#f0fdf4", padding: 16, borderRadius: 12 }}>
              <label style={labelStyle}>Subject ID</label>
              <p style={{ fontSize: 18, fontWeight: 600 }}>{practiceSet.subject_id}</p>
            </div>
            <div style={{ background: "#f0fdf4", padding: 16, borderRadius: 12 }}>
              <label style={labelStyle}>Number of Questions</label>
              <p style={{ fontSize: 18, fontWeight: 600 }}>{practiceSet.num_questions}</p>
            </div>
            <div style={{ background: "#f0fdf4", padding: 16, borderRadius: 12 }}>
              <label style={labelStyle}>Duration (minutes)</label>
              <p style={{ fontSize: 18, fontWeight: 600 }}>{practiceSet.duration_minutes}</p>
            </div>
          </div>
        </div>

        {/* Questions Table */}
        <div style={{ background: "white", borderRadius: 16, boxShadow: "0 10px 30px rgba(0,0,0,0.08)", overflow: "hidden" }}>
          <div style={{ padding: "20px 24px", background: "#1e293b", color: "white" }}>
            <h3 style={{ margin: 0 }}>
              Questions
              <span style={{ marginLeft: 12, fontSize: 15, opacity: 0.9 }}>
                ({practiceSet.questions.length} Total)
              </span>
            </h3>
          </div>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead style={{ background: "#f1f5f9" }}>
              <tr>
                <th style={th}>#</th>
                <th style={th}>Question</th>
                <th style={th}>A</th>
                <th style={th}>B</th>
                <th style={th}>C</th>
                <th style={th}>D</th>
                <th style={th}>Correct</th>
              </tr>
            </thead>
            <tbody>
              {practiceSet.questions.map((q, index) => (
                <tr key={q.id} style={{ background: index % 2 === 0 ? "#f8fafc" : "white" }}>
                  <td style={td}>{index + 1}</td>
                  <td style={td}>{q.text}</td>
                  <td style={td}>{q.option_a}</td>
                  <td style={td}>{q.option_b}</td>
                  <td style={td}>{q.option_c}</td>
                  <td style={td}>{q.option_d}</td>
                  <td style={td}>
                    <span style={{ background: "#d1fae5", color: "#065f46", padding: "6px 12px", borderRadius: 20 }}>
                      {q.correct}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {practiceSet.questions.length === 0 && (
            <p style={{ textAlign: "center", padding: 40, color: "#64748b" }}>
              No questions assigned to this Practice Set
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

// Styles – bilkul tumhare Edit screenshot jaisa
const th = {
  padding: "18px 16px",
  textAlign: "left",
  fontWeight: 600,
  fontSize: 14,
  color: "#1e293b",
  borderBottom: "1px solid #e2e8f0"
};

const td = {
  padding: "18px 16px",
  fontSize: 14,
  color: "#475569",
  borderBottom: "1px solid #e2e8f0"
};

const labelStyle = {
  display: "block",
  marginBottom: 8,
  fontSize: 14,
  fontWeight: 600,
  color: "#1e293b"
};